export const FORD_SIMULATOR_SERVERS = Object.freeze([
  { key: 'cn', label: 'CN 服务器', origin: 'https://diagapi.cn.wwftool.top' },
  { key: 'us', label: 'US 服务器', origin: 'https://diagapi.us.wwftool.top' },
]);

export const CUSTOM_TEMPLATE_STORAGE_KEY = 'FordDiagnosticSimulator:Templates:v2';

export const DEFAULT_SIMULATOR_FORM = Object.freeze({
  serverKey: 'cn',
  engine: 'new',
  templateKey: 'connect',
  diagId: 'USAFORD',
  diagVersion: 'V50.80',
  language: 'CN',
  sn: '989340000121',
  vin: '1FA6P8CF5R5407760',
  localMac: 'w8C8Cw03Cw03Cw03Cw03Cw03C',
  tcurl: 'x431',
  wifiMac: 'wCscwGswSJDw4JPwC6E.03E',
  wifiName: 'Xb6MfrsR3XpN.G3E',
  productType: 'x431',
});

const COMMON_SAMPLE = Object.freeze({
  diagId: 'USAFORD',
  diagVersion: 'V50.80',
  language: 'CN',
  sn: '989340000121',
  vin: '1FA6P8CF5R5407760',
});

function encodeBase64(value) {
  if (typeof Buffer !== 'undefined') return Buffer.from(value, 'utf8').toString('base64');
  const bytes = new TextEncoder().encode(value);
  let binary = '';
  bytes.forEach((byte) => { binary += String.fromCharCode(byte); });
  return btoa(binary);
}

const DTC_SAMPLE = encodeBase64(JSON.stringify({
  jmccar: 255,
  dtclist: [{ spe: 'UDS', uid: 'G1273131', dtc: [1000] }],
}));

function makeTemplate(key, title, funcPath, funcType, parm = {}, options = {}) {
  return {
    key,
    title,
    funcPath,
    funcType,
    builtin: true,
    legacySupported: options.legacySupported !== false,
    legacyFuncType: options.legacyFuncType ?? funcType,
    sample: { ...COMMON_SAMPLE, ...(options.sample || {}) },
    parm,
    fields: options.fields || {},
  };
}

export const BUILTIN_SIMULATOR_TEMPLATES = Object.freeze([
  makeTemplate('securityOffline', '1 离线安全数据', 'SecurityOffline', '1', {
    xmlFileName: 'IVS_FORD.xml', Addr: '7E0', AssyPN: 'FS71-14C204-FG', SubLevel: '01', SafeBytes: '12345678', SecurityBytes: '0',
  }, { fields: { xmlFileName: { label: 'XML 文件名' }, Addr: { label: '模块地址' }, AssyPN: { label: '零件号' }, SubLevel: { label: '子级别' }, SafeBytes: { label: '安全字节' }, SecurityBytes: { label: '安全数据类型' } } }),
  makeTemplate('immoAutoPats', '3 PATS 自动计算', 'ImmoAutoPats', '3', { OutCode: '0040123456000000' }, { fields: { OutCode: { label: 'OutCode' } } }),
  makeTemplate('immoAuto3Bto3C', '4 3B 转 3C', 'ImmoAuto3Bto3C', '4', { OutCode: '3B7A1C2D3E4F' }, { fields: { OutCode: { label: '3B OutCode' } } }),
  makeTemplate('securityOnline', '5 在线安全数据', 'SecurityOL', '5', {
    AssyPN: 'FS71-14C204-FG', Addr: '7E0', SafeBytes: '12345678', SubLevel: '01', encryption: '0',
  }, { fields: { AssyPN: { label: '零件号' }, Addr: { label: '模块地址' }, SafeBytes: { label: '安全字节' }, SubLevel: { label: '子级别' }, encryption: { label: '加密标志' } } }),
  makeTemplate('immoIncode', '6 在线防盗计算', 'ImmoIncode', '6', { Type: '0', Outcode: '0040123456000000', encryption: '0' }, { fields: { Type: { label: '请求类型' }, Outcode: { label: 'Outcode' }, encryption: { label: '加密标志' } } }),
  makeTemplate('deliv4Vin', '10 VIN 数据键', 'Deliv4Vin', '10'),
  makeTemplate('connect', '11 连接检查', 'connect', '11'),
  makeTemplate('pmiData', '12 PMI 模块数据', 'PMIData', '12', { ModAddr: '7E0', aes: '0' }, { fields: { ModAddr: { label: '模块地址' }, aes: { label: 'AES 标志' } } }),
  makeTemplate('tcmIdn', '14 TCM IDN', 'TCMIDN', '14', { TranStrategy: '2541213712850' }, { legacyFuncType: '16', fields: { TranStrategy: { label: '变速箱策略号' } } }),
  makeTemplate('findCanFd', '15 CAN-FD 探测', 'FindCANFD', '15', { FindCANFD: '0', Flag: '0', ModAddr: '7E0' }, { fields: { FindCANFD: { label: '新工具探测标志' }, Flag: { label: '旧工具探测标志' }, ModAddr: { label: '模块地址' } } }),
  makeTemplate('vin2Vq', '18 VIN 转 VQ', 'VIN2VQ', '18', { ffdata_version: 132 }, { fields: { ffdata_version: { label: 'FFData 版本', input: 'number' } } }),
  makeTemplate('downloadVm', '19 下载 VM 数据', 'DownloadVM', '19', { iReqFlag: 0 }, { fields: { iReqFlag: { label: '请求标志', input: 'number' } } }),
  makeTemplate('multPromptText', '20 多语言文本', 'MultpromptText', '20', { TextId: '0x000413F6' }, { fields: { TextId: { label: '文本 ID' } } }),
  makeTemplate('multPromptDtc', '21 DTC 多语言文本', 'MultpromtDTC', '21', { JReq: DTC_SAMPLE }, { fields: { JReq: { label: 'DTC 请求（Base64）', input: 'textarea' } } }),
  makeTemplate('diagMod', '23 诊断结构判断', 'DiagMod', '23', { ExistsFN: '1', FN: '1' }, { fields: { ExistsFN: { label: '是否存在 FN' }, FN: { label: 'FN 标志' } } }),
  makeTemplate('keyCode', '24 KeyCode 映射', 'KeyCode', '24', { Type: 0, KCP: '123456' }, { fields: { Type: { label: '映射类型', input: 'number' }, KCP: { label: 'KCP 六位序列号' } } }),
  makeTemplate('soVersion', '28 SO 版本', 'SoVersion', '28', { Type: 1 }, { fields: { Type: { label: '产品类型', input: 'number' } } }),
  makeTemplate('olCfg', '29 在线配置', 'OLCfg', '29'),
  makeTemplate('collectData', '30 数据采集', 'CollectData', '30', {
    Data: {
      vin: '1FA6P8CF5R5407760',
      fc_list: 'F188,F190',
      sys_list: [{ address: '7E0', protocol: 'HS-CAN', spec: 'UDS', pn_list: [{ id: 'F188', type: 1, value: 'FS71-14C204-FG' }] }],
    },
  }, {
    legacySupported: false,
    fields: {
      'Data.vin': { label: '采集 VIN' }, 'Data.fc_list': { label: '功能列表' },
      'Data.sys_list.0.address': { label: '系统地址' }, 'Data.sys_list.0.protocol': { label: '协议' },
      'Data.sys_list.0.spec': { label: '诊断规范' }, 'Data.sys_list.0.pn_list.0.id': { label: '零件数据 ID' },
      'Data.sys_list.0.pn_list.0.type': { label: '零件数据类型', input: 'number' },
      'Data.sys_list.0.pn_list.0.value': { label: '零件数据值' },
    },
  }),
  makeTemplate('sysFuncCfg', '32 系统功能配置', 'SysFuncCfg', '32'),
]);

function clone(value) {
  return JSON.parse(JSON.stringify(value));
}

function isPlainObject(value) {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
}

function normalizeTemplate(raw, builtin = false) {
  const key = String(raw?.key || '').trim();
  const title = String(raw?.title || '').trim();
  const funcPath = String(raw?.funcPath || '').trim();
  const funcType = String(raw?.funcType || '').trim();
  if (!key || !title || !funcPath || !funcType) return null;
  return {
    key, title, funcPath, funcType, builtin,
    legacySupported: raw?.legacySupported !== false,
    legacyFuncType: String(raw?.legacyFuncType ?? funcType),
    sample: isPlainObject(raw?.sample) ? clone(raw.sample) : clone(COMMON_SAMPLE),
    parm: isPlainObject(raw?.parm) ? clone(raw.parm) : {},
    fields: isPlainObject(raw?.fields) ? clone(raw.fields) : {},
  };
}

function safeStorage(storage) {
  if (storage) return storage;
  if (typeof window !== 'undefined') return window.localStorage;
  return null;
}

export function loadCustomTemplates(storage) {
  const target = safeStorage(storage);
  if (!target) return [];
  try {
    const parsed = JSON.parse(target.getItem(CUSTOM_TEMPLATE_STORAGE_KEY) || '[]');
    if (!Array.isArray(parsed)) return [];
    return parsed.map((item) => normalizeTemplate(item, false)).filter(Boolean);
  } catch {
    return [];
  }
}

export function saveCustomTemplates(templates, storage) {
  const target = safeStorage(storage);
  const normalized = (Array.isArray(templates) ? templates : []).map((item) => normalizeTemplate(item, false)).filter(Boolean);
  if (target) target.setItem(CUSTOM_TEMPLATE_STORAGE_KEY, JSON.stringify(normalized));
  return normalized;
}

export function upsertCustomTemplate(template, storage) {
  const normalized = normalizeTemplate(template, false);
  if (!normalized) throw new Error('模板名称、接口路径和功能类型不能为空');
  if (BUILTIN_SIMULATOR_TEMPLATES.some((item) => item.key === normalized.key)) throw new Error('模板标识不能与内置模板重复');
  const list = loadCustomTemplates(storage);
  const index = list.findIndex((item) => item.key === normalized.key);
  if (index >= 0) list.splice(index, 1, normalized);
  else list.push(normalized);
  return saveCustomTemplates(list, storage);
}

export function removeCustomTemplate(key, storage) {
  return saveCustomTemplates(loadCustomTemplates(storage).filter((item) => item.key !== key), storage);
}

export function getAllSimulatorTemplates(storage) {
  return [...BUILTIN_SIMULATOR_TEMPLATES.map((item) => clone(item)), ...loadCustomTemplates(storage)];
}

export function findSimulatorTemplate(key, storage) {
  const templates = getAllSimulatorTemplates(storage);
  return templates.find((item) => item.key === key) || templates[0];
}

export function getSimulatorTemplateDefaults(key, storage) {
  const template = findSimulatorTemplate(key, storage);
  return { ...clone(DEFAULT_SIMULATOR_FORM), ...clone(template.sample || {}), templateKey: template.key, parm: clone(template.parm || {}) };
}

function flattenValue(value, prefix, rows, fields) {
  if (Array.isArray(value)) {
    value.forEach((item, index) => flattenValue(item, prefix ? `${prefix}.${index}` : String(index), rows, fields));
    return;
  }
  if (isPlainObject(value)) {
    Object.entries(value).forEach(([key, child]) => flattenValue(child, prefix ? `${prefix}.${key}` : key, rows, fields));
    return;
  }
  const config = fields?.[prefix] || {};
  rows.push({ path: prefix, label: config.label || prefix, input: config.input || (typeof value === 'number' ? 'number' : String(value ?? '').length > 70 ? 'textarea' : 'text'), value });
}

export function flattenParameterFields(parm, fields = {}) {
  const rows = [];
  flattenValue(parm || {}, '', rows, fields);
  return rows;
}

export function getParameterValue(target, path) {
  return String(path).split('.').reduce((value, key) => value?.[key], target);
}

export function setParameterValue(target, path, value) {
  const keys = String(path).split('.').filter(Boolean);
  if (!keys.length) return target;
  let cursor = target;
  keys.slice(0, -1).forEach((key, index) => {
    const nextIsArray = /^\d+$/.test(keys[index + 1]);
    if (cursor[key] === undefined || cursor[key] === null) cursor[key] = nextIsArray ? [] : {};
    cursor = cursor[key];
  });
  cursor[keys[keys.length - 1]] = value;
  return target;
}

export function removeParameterValue(target, path) {
  const keys = String(path).split('.').filter(Boolean);
  if (!keys.length) return target;
  let cursor = target;
  keys.slice(0, -1).forEach((key) => { cursor = cursor?.[key]; });
  if (cursor) {
    const last = keys[keys.length - 1];
    if (Array.isArray(cursor)) cursor.splice(Number(last), 1);
    else delete cursor[last];
  }
  return target;
}

function displayValue(value) {
  if (value === null || value === undefined) return '';
  if (typeof value === 'boolean') return value ? '是' : '否';
  return String(value);
}

export function flattenDisplayRows(value, prefix = '') {
  const rows = [];
  const visit = (current, path) => {
    if (Array.isArray(current)) {
      if (!current.length) rows.push({ label: path || '结果', value: '空列表' });
      current.forEach((item, index) => visit(item, path ? `${path}[${index + 1}]` : `[${index + 1}]`));
      return;
    }
    if (isPlainObject(current)) {
      const entries = Object.entries(current);
      if (!entries.length) rows.push({ label: path || '结果', value: '无数据' });
      entries.forEach(([key, child]) => visit(child, path ? `${path}.${key}` : key));
      return;
    }
    rows.push({ label: path || '结果', value: displayValue(current) });
  };
  visit(value, prefix);
  return rows;
}

function getServer(serverKey) {
  return FORD_SIMULATOR_SERVERS.find((item) => item.key === serverKey) || FORD_SIMULATOR_SERVERS[0];
}

function normalizeForm(options) {
  return { ...DEFAULT_SIMULATOR_FORM, ...(options || {}) };
}

export function buildBasicParm(options) {
  const form = normalizeForm(options);
  return { DiagId: form.diagId, DiagVersion: form.diagVersion, Languege: form.language, LocalMac: form.localMac, TCURL: form.tcurl, WifiMac: form.wifiMac, WifiName: form.wifiName };
}

export function buildNewToolBody(options, storage) {
  const form = normalizeForm(options);
  const template = findSimulatorTemplate(form.templateKey, storage);
  return { BasicParm: buildBasicParm(form), Parm: clone(isPlainObject(form.parm) ? form.parm : template.parm), autoCode: form.diagId, sn: form.sn, vin: form.vin };
}

export function buildLegacyVehicleData(options) {
  const form = normalizeForm(options);
  return [
    ['Vin', form.vin], ['BoxInfo', 'NULL'], ['Uid', 'NULL'], ['DiagVersion', form.diagVersion],
    ['DiagId', form.diagId], ['Languege', form.language], ['LocalMac', form.localMac],
    ['WifiMac', form.wifiMac], ['WifiName', form.wifiName], ['TCURL', form.tcurl],
  ].map(([key, value]) => `${key},${value}!`).join('');
}

function legacyBusinessArguments(template, form, parm) {
  switch (String(template.funcType)) {
    case '1': return [parm.xmlFileName, parm.Addr, parm.AssyPN, parm.SubLevel, parm.SafeBytes, parm.SecurityBytes];
    case '3':
    case '4': return [parm.OutCode];
    case '5': return [form.vin, parm.AssyPN, parm.Addr, parm.SafeBytes, parm.SubLevel, parm.encryption];
    case '6': return [parm.Type, form.vin, parm.Outcode, parm.encryption, form.sn];
    case '10': return [form.vin, form.sn];
    case '11': return [];
    case '12': return [form.vin, form.sn, parm.ModAddr, parm.aes];
    case '14': return [form.vin, parm.TranStrategy];
    case '15': return [parm.Flag ?? parm.FindCANFD, form.vin, parm.ModAddr];
    case '18': return [form.vin, form.sn, form.diagVersion];
    case '19': return [form.vin, form.sn, parm.iReqFlag];
    case '20': return [form.vin, form.sn, form.language, form.diagVersion, parm.TextId];
    case '21': return [parm.JReq];
    case '23': return [form.vin, parm.ExistsFN];
    case '24': return [parm.Type, parm.KCP];
    case '28': return [parm.Type];
    case '29':
    case '32': return [];
    default: return Object.values(parm);
  }
}

function assertLegacySupported(template) {
  if (template.legacySupported === false) throw new Error(`${template.title} 不支持旧工具请求`);
}

export function buildLegacyMessageBody(options, storage) {
  const form = normalizeForm(options);
  const template = findSimulatorTemplate(form.templateKey, storage);
  assertLegacySupported(template);
  const parm = clone(isPlainObject(form.parm) ? form.parm : template.parm);
  const args = legacyBusinessArguments(template, form, parm).concat(['$AUTH$', form.sn, '$CC$', '$IP$', buildLegacyVehicleData(form)]);
  return `/${template.legacyFuncType}/${args.map((item) => String(item ?? '')).join('/')}`;
}

function quoteCommandArgument(value) {
  const text = String(value ?? '');
  if (!/[\s"]/u.test(text)) return text;
  return `"${text.replace(/"/g, '\\"')}"`;
}

export function buildLegacyExeCommand(options, storage) {
  const form = normalizeForm(options);
  const template = findSimulatorTemplate(form.templateKey, storage);
  assertLegacySupported(template);
  const parm = clone(isPlainObject(form.parm) ? form.parm : template.parm);
  const args = [template.legacyFuncType].concat(legacyBusinessArguments(template, form, parm)).concat(['$AUTH$', form.sn, '$CC$', '$IP$', buildLegacyVehicleData(form)]);
  return ['Tool_FordServer.exe', ...args.map(quoteCommandArgument)].join(' ');
}

export function buildSimulatorRunRequest(options, storage) {
  const form = normalizeForm(options);
  const template = findSimulatorTemplate(form.templateKey, storage);
  if (form.engine === 'legacy') assertLegacySupported(template);
  return { serverKey: form.serverKey, engine: form.engine, templateKey: template.key, sn: form.sn, vin: form.vin, diagId: form.diagId, diagVersion: form.diagVersion, language: form.language, localMac: form.localMac, tcurl: form.tcurl, wifiMac: form.wifiMac, wifiName: form.wifiName, productType: form.productType, parm: clone(isPlainObject(form.parm) ? form.parm : template.parm) };
}

export function buildSimulatorPayload(options, storage) {
  const form = normalizeForm(options);
  const template = findSimulatorTemplate(form.templateKey, storage);
  const server = getServer(form.serverKey);
  if (form.engine === 'legacy') {
    return { engine: 'legacy', template, server, endpoint: `${server.origin}/api/v1/admin/ford/simulator/run`, simulatorBody: buildSimulatorRunRequest(form, storage), messageBody: buildLegacyMessageBody(form, storage), exeCommand: buildLegacyExeCommand(form, storage) };
  }
  return { engine: 'new', template, server, endpoint: `${server.origin}/api/v1/admin/ford/simulator/run`, targetEndpoint: `${server.origin}/api/v1/funcEx/${template.funcPath}`, simulatorBody: buildSimulatorRunRequest(form, storage), requestBody: buildNewToolBody(form, storage) };
}
